
export const processNestedDataforReadOnly = (data, selectedPersonsState,source) => {
  let results = [];

  const isMongoDBObjectID = (id) => /^[a-f\d]{24}$/i.test(id);

  if (data && data.length) {
    data.forEach((item) => {
      if (!item?.isCorp && item?.isReadOnly) {
        if (item.personId?._id && isMongoDBObjectID(item.personId._id)) {
          // Only send personId if it's a valid MongoDB ObjectID
          if(source==="emailPreview"){
            results.push(
              { personId: item.personId._id ,
                ...(item.personId.fullName && { fullName: item.personId?.fullName }),
                ...(item.personId.email && { email: item.personId?.email }),
              ...{clientType:"Read_Only_Client"}
            }); 
          }else{
          results.push({ personId: item.personId._id ,
           
          });
        }
        } else {
          if(source==="emailPreview"){
          results.push({
            ...(item.personId.fullName && { fullName: item.personId?.fullName }),
            ...(item.personId.email && { email: item.personId?.email }),
            ...{clientType:"Read_Only_Client"}
          });
        }else{
          results.push({
            ...(item.personId.fullName && { fullName: item.personId?.fullName }),
            ...(item.personId.email && { email: item.personId?.email }),
           });
        }
        }
      } else if (item?.isCorp && item?.signers?.length > 0) {
        // Handle the case for corps
        item.signers.forEach((signer) => {
          if (signer.isReadOnly) {
            if (signer.personId?._id && isMongoDBObjectID(signer.personId?._id)) {
              if(source==="emailPreview"){
              results.push({ personId: signer.personId._id ,
                corpName:item?.fullName,
                iscorp:true,
                clientType:"Read_Only_Client"
              });
            }else{
              results.push({ 
                personId: signer.personId._id ,

              });
            }
            } else {
              results.push({
                ...(signer.personId?.email && { email: signer.personId.email }),
              });
            }
          }
        });
      }
    });
  }
  if (Array.isArray(selectedPersonsState?.titleRepsData) && selectedPersonsState.titleRepsData.length) {
    selectedPersonsState.titleRepsData.forEach((item) => {
      results.push({
        ...(item.fullName && { fullName: item?.fullName }),
        ...(item.email && { email: item?.email }),
        ...{ clientType: "Title_Company_Rep" },
        openFor: "TITLE_COMPANY",
      });
    });
  }
  if (Array.isArray(selectedPersonsState?.affiliatesData) && selectedPersonsState.affiliatesData.length) {
    selectedPersonsState.affiliatesData.forEach((item) => {
      results.push({
        ...(item.fullName && { fullName: item?.fullName }),
        ...(item.email && { email: item?.email }),
         ...{clientType:"Read_Only_Client"},
        openFor: "AFFILIATES",
      });
    });
  }

  return results;
};

export const processSelectedAgentsData = (agentsData) => {
  if (!Array.isArray(agentsData) || !agentsData.length) return [];
  const agents = agentsData.map((agent) => ({
    fullName: agent?.fullName || "",
    email: agent?.email,
    ...(agent?.key && { key: agent?.key }),
    ...(agent?.personId && { personId: agent?.personId }),
  }));
  return agents;
};
